import BasePage from '../../components/base-page/base-page';
import ContactModal from '../../components/contact-modal/contact-modal';
import type { UiElement } from '../../../shared/ui-element/ui-element';

import './developers.scss';


class DevelopersPage extends BasePage {
  contactModal = new ContactModal();

  onInit() {
    super.onInit();
    (this.contactModal as UiElement).init();
  }
}

export default DevelopersPage;

(DevelopersPage as UiElement).initOnDomLoaded();
